module.exports = __webpack_public_path__ + "static/media/img01.2a3e74b3.JPG";